import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";

const getRechargeRequests = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_RECHARGE_REQUESTS + queryParams,
      "GET",
      { "Content-Type": "application/json" }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const approveRechargeRequest = (id, adminNote, approvalPassword) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_RECHARGE_APPROVE + `/${id}/approve`,
      "PUT",
      { "Content-Type": "application/json" },
      JSON.stringify({ adminNote: adminNote || "", approvalPassword: approvalPassword || "" })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const rejectRechargeRequest = (id, adminNote, approvalPassword) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_RECHARGE_REJECT + `/${id}/reject`,
      "PUT",
      { "Content-Type": "application/json" },
      JSON.stringify({ adminNote: adminNote || "", approvalPassword: approvalPassword || "" })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const getRechargeWalletInfo = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_RECHARGE_WALLET_INFO + `/${id}/wallet-info`,
      "GET",
      { "Content-Type": "application/json" }
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

const deductFromRecharge = (id, amount, approvalPassword) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl + NetworkConfiguration.ADMIN_RECHARGE_DEDUCT + `/${id}/deduct`,
      "PUT",
      { "Content-Type": "application/json" },
      JSON.stringify({ amount: Number(amount), approvalPassword: approvalPassword || "" })
    )
      .then((res) => resolve(res))
      .catch((err) => reject(err));
  });
};

export const rechargeRequestApiService = {
  getRechargeRequests,
  approveRechargeRequest,
  rejectRechargeRequest,
  getRechargeWalletInfo,
  deductFromRecharge,
};
